import React from "react";
import "./index.less";
import ScrollOverPack from "rc-scroll-anim/lib/ScrollOverPack";
import "rc-texty/assets/index.css";
import { OverPack } from "rc-scroll-anim";
import { Col } from "antd";
import QueueAnim from "rc-queue-anim";

export default class content2 extends React.Component {
//   白天、黑夜、阴天 
// 正射影像、倾斜影像、激光点云 
// DOM、DEM、DSM、DLG、 
// 纹理、灰度、反射率、光谱信息 
// 正射、倾斜、激光、 高精度位置信息、高精度姿态信息 
// 影像瑕疵少、点云瑕疵少、大高差 
// 作业时效快、采集效率高
  render() {
    return (
      <ScrollOverPack id="craft" className="allElements-content2">
        <h1>全时段|全种类|全内容|全融合|全应对</h1>
        <OverPack className="text-content">
          <Col xs={24} sm={24} md={12} lg={12} xl={24}>
            <QueueAnim key="queue" leaveReverse>
              <div key="a" className="code-box-shape queue-anim-demo">
                <span>白 </span>天、<span>黑 </span>夜、<span>阴 </span>天
              </div>
              <div key="a" className="code-box-shape queue-anim-demo">
                <span>正射 </span>影像、<span>倾斜 </span>影像、
                <span>激光 </span>点云
              </div>
            </QueueAnim>
          </Col>
        </OverPack>
        <OverPack className="text-content">
          <Col xs={24} sm={24} md={12} lg={12} xl={24}>
            <QueueAnim key="queue" leaveReverse>
              <div key="b" className="code-box-shape queue-anim-demo">
                <span>DOM、DEM、DSM、DLG</span>
              </div>
              <div key="b" className="code-box-shape queue-anim-demo">
                <span>纹理、灰度、反射率、光谱信息 </span>
              </div>
            </QueueAnim>
          </Col>
        </OverPack>
        <OverPack className="text-content">
          <Col xs={24} sm={24} md={12} lg={12} xl={24}>
            <QueueAnim key="queue" leaveReverse>
              <div key="c" className="code-box-shape queue-anim-demo">
                正射、倾斜、激光、 <span>高精度 </span>
                位置信息、高精度姿态信息
              </div>
              <div key="c" className="code-box-shape queue-anim-demo">
                影像瑕疵少、点云<span> 瑕疵少</span>、大高差
              </div>
              <div key="c" className="code-box-shape queue-anim-demo">
                作业时效<span> 快</span>、采集效率<span> 高</span>
              </div>
            </QueueAnim>
          </Col>
        </OverPack>
      </ScrollOverPack>
    );
  }
}
